<script>
import OverviewChartSeriesSelector from './OverviewChartSeriesSelector.vue';
import AdvertisementLineChart from '../common/AdvertisementLineChart.vue';
import { format as formatNumber } from '@/utils/number';

export default {
  name: 'CampaignOverviewChart',
  components: {
    AdvertisementLineChart,
    OverviewChartSeriesSelector,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    xAxis: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      singleYAxis: false,
      seriesConfigs: [],
      yAxisConfig: [],
    };
  },
  computed: {
    config() {
      return {
        chart: {
          height: 350,
          spacingBottom: 50,
        },
        tooltip: {
          pointFormatter() {
            return `
              <div>
                <b style="color:${this.color}">${this.series.name}:</b>
                <b>${formatNumber(Math.round(this.y))}</b>
              </div>`;
          },
        },
        xAxis: { categories: this.xAxis },
        series: [...this.seriesConfigs],
        yAxis: [...this.yAxisConfig],
      };
    },
    chartColors() {
      return ['#0EA960', '#F9A825'];
    },
  },
  watch: {
    series: {
      immediate: true,
      handler() {
        if (!this.series?.length) return;

        const seriesConfigs = this.series?.map((seriesConfig, i) => ({
          ...seriesConfig,
          visible: i < 2,
          color: this.chartColors[i],
        }));

        this.updateChartData(seriesConfigs);
      },
    },
    singleYAxis: {
      handler() {
        this.seriesConfigs = this.setSeriesYAxis(this.seriesConfigs);
      },
    },
  },
  methods: {
    updateChartData(updatedSeriesList) {
      this.seriesConfigs = this.setSeriesYAxis(updatedSeriesList);
      this.updateChartYAxis();
    },
    setSeriesYAxis(seriesList) {
      let yAxis = 0;
      return seriesList.map(series => {
        if (!series.visible) return series;
        return {
          ...series,
          yAxis: this.singleYAxis ? 0 : yAxis++,
        };
      });
    },
    updateChartYAxis() {
      const activeSeries = this.seriesConfigs.filter(series => series.visible);

      this.yAxisConfig = [
        { title: { text: activeSeries?.[0]?.name } },
        {
          title: { text: activeSeries?.[1]?.name },
          opposite: true,
        },
      ];
    },
  },
};
</script>

<template>
  <div class="campaign-overview-chart">
    <OverviewChartSeriesSelector
      v-if="seriesConfigs?.length"
      :series="seriesConfigs"
      :colors="chartColors"
      :min-select="1"
      :max-select="2"
      @change="updateChartData"
    />

    <AdvertisementLineChart :config="config" />

    <ElSwitch
      v-model="singleYAxis"
      :active-text="$t('ADVERTISEMENT.OVERVIEW.CHART_SAME_AXIS')"
    />
  </div>
</template>
